import { forwardRef } from 'react';
import { useIntl } from 'react-intl';

import { getCurrencySymbol } from 'src/utils/i18n';

import { Input } from '../index';
import { useNumberInput } from '@chakra-ui/react';
import {
  formatNumberToString,
  parseStringToNumber,
  isValidCharacter,
} from 'src/utils/formatNumber';

const CurrencyInput = ({ ...props }, ref) => {
  const intl = useIntl();

  const { getInputProps } = useNumberInput({
    defaultValue: 0,
    step: 0.25,
    min: 0,
    precision: 2,
    format: value => formatNumberToString(value),
    parse: value => parseStringToNumber(value),
    isValidCharacter: char => isValidCharacter(char),
    ...props,
  });

  const inputProps = getInputProps();

  return (
    <Input
      placeholder="0,00"
      leftElement={getCurrencySymbol(intl)}
      {...props}
      {...inputProps}
      ref={ref}
    />
  );
};

const ForwardWithRef = forwardRef(CurrencyInput);

export { ForwardWithRef as CurrencyInput };
